import { render, staticRenderFns } from "./AppDefaultFooter.vue?vue&type=template&id=6fa4c9e1&scoped=true&"
import script from "./AppDefaultFooter.vue?vue&type=script&lang=ts&"
export * from "./AppDefaultFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AppDefaultFooter.vue?vue&type=style&index=0&id=6fa4c9e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4c9e1",
  null
  
)

export default component.exports